import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UserManagement',
  methods: {
    createUser: function createUser() {
      this.$router.push({
        name: 'user-create'
      });
    },
    navigateToOverview: function navigateToOverview() {
      this.$router.push({
        name: 'user-management'
      });
    }
  },
  data: function data() {
    return {
      routerKey: 0
    };
  },
  computed: {
    isInOverview: function isInOverview() {
      return this.$route.name === 'user-management';
    }
  },
  watch: {
    $route: function $route(to, from) {
      // Reset component when going from user creation to editing (to force props to update)
      if (from.name === 'user-create' && to.name === 'user-edit') {
        this.routerKey++;
      }
    }
  }
};